module.exports = __webpack_public_path__ + "static/logosm-a0ef2ffa3b7d0134aef6951646612cad.jpg";